import { createStore } from 'zustand/vanilla'

export interface Connectivity {
  /** The browser's own view (navigator.onLine and its online/offline events). */
  online: boolean
  /** False after a request failed to reach the server, until one succeeds again. */
  serverReachable: boolean
}

const initialOnline = typeof navigator === 'undefined' ? true : navigator.onLine !== false

export const connectivity = createStore<Connectivity>(() => ({ online: initialOnline, serverReachable: true }))

/** The API client reports every response and every network failure here. */
export function reportReachable(reachable: boolean): void {
  if (connectivity.getState().serverReachable !== reachable) connectivity.setState({ serverReachable: reachable })
}

let listening = false

/** Follows the browser's online/offline events; idempotent, called once by the signed-in layout. */
export function watchConnectivity(): void {
  if (listening || typeof window === 'undefined') return
  listening = true
  const update = () => {
    const online = navigator.onLine !== false
    connectivity.setState(online ? { online } : { online, serverReachable: false })
  }
  window.addEventListener('online', update)
  window.addEventListener('offline', update)
}
